// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__UDDYf","spinner":"Loader_spinner__iDFIv","spin":"Loader_spin__E4RJ0"};